<script setup>
import { RouterView } from 'vue-router'
/* import Lenis from '@studio-freight/lenis'; */
import { ModalsContainer } from 'vue-final-modal'
import NavHeader from '@/components/Base/NavHeader.vue'
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();

onMounted(() => {
  // Configurar el token en los headers de axios al iniciar la aplicación
  authStore.setupAxiosToken();
  
  // Opcionalmente también podemos verificar la autenticación
  authStore.checkAuth();
});

/* const lenis = new Lenis();

lenis.on('scroll', (e) => {
    // console.log(e);
});

function raf (time) {
   lenis.raf(time)
     requestAnimationFrame(raf)
}

requestAnimationFrame(raf); */
</script>

<template>
  <NavHeader />
  <RouterView />
  <ModalsContainer />
</template>

<style scoped>


</style>
